import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .map-wrapper {
    width: 403px;
  }

  .map-container {
    width: 403px;
    height: 100%;
    border-radius: 0 12px 12px 0;
  }

  .widgets-container {
    display: flex;
    border-radius: 12px;
    background-color: ${(props) => props.theme.colors.widget_background};
    overflow: hidden;
  }

  .actions-wrapper {
    width: 100%;
    margin-left: 32px;
    display: flex;
    gap: 32px;

    .border-line {
      content: '';
      height: 44px;
      border-right: 1px solid ${(props) => props.theme.colors.outline};
    }
  }

  .details-row .preview-container .overview-container {
    background-color: transparent;
  }

  .details-row .actions-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .trip-score-chart {
    flex: 1;
    min-width: 0;
  }

  .trip-score-knob {
    width: 220px;
    flex-shrink: 0;
  }
`;

const Widget = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  flex: 1;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  overflow: hidden;

  .widget-name {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    color: ${(props) => props.theme.colors.white};
  }
`;

const Row = styled.div`
  display: flex;
  gap: 20px;
`;

export default { Wrapper, Widget, Row };
